import React from "react";

export const AnimatedCheck = () => (
  <svg role="img" aria-label="Success" viewBox="0 0 64 64" className="h-20 w-20">
    <circle className="animated-check-circle" cx="32" cy="32" r="30" fill="#16a34a" />
    <path
      className="animated-check-stroke"
      d="M18 33 L28 43 L46 23"
      fill="none"
      stroke="#ffffff"
      strokeWidth="5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
